import React, { useState } from 'react';
import { X, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

const DeclineModal = ({ isOpen, onClose, solicitud, onConfirm, isLoading }) => {
  const [justificacion, setJustificacion] = useState('');
  const [error, setError] = useState('');

  if (!isOpen || !solicitud) return null;

  const handleSubmit = () => {
    if (!justificacion.trim()) {
      setError('La justificación es requerida');
      return;
    }

    if (justificacion.trim().length < 10) {
      setError('La justificación debe tener al menos 10 caracteres');
      return;
    }

    onConfirm(justificacion.trim());
  };

  const handleClose = () => {
    setJustificacion('');
    setError('');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b">
          <div className="flex items-center gap-3">
            <div className="bg-red-100 p-2 rounded-lg">
              <AlertTriangle className="h-5 w-5 text-red-600" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900">
              Declinar Solicitud
            </h2>
          </div>
          <button
            onClick={handleClose}
            disabled={isLoading}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {/* Información de la solicitud */}
          <div className="bg-gray-50 p-4 rounded-lg space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Edificio:</span>
              <span className="font-medium">{solicitud.edificio?.nombre}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Activo:</span>
              <span className="font-medium">{solicitud.hospedaje?.nombre || solicitud.nombrePropiedad}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Items solicitados:</span>
              <span className="font-medium">{solicitud.total_solicitado}</span>
            </div>
          </div>

          {/* Advertencia */}
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <p className="text-sm text-red-800">
              <strong>Advertencia:</strong> Esta acción no se puede deshacer. La solicitud será marcada como declinada y no podrá ser procesada.
            </p>
          </div>

          {/* Campo de justificación */}
          <div className="space-y-2">
            <Label htmlFor="justificacion" className="text-sm font-medium">
              Justificación <span className="text-red-500">*</span>
            </Label>
            <Textarea
              id="justificacion"
              value={justificacion}
              onChange={(e) => {
                setJustificacion(e.target.value);
                setError('');
              }}
              placeholder="Ingrese el motivo por el cual se declina esta solicitud..."
              rows={4}
              className={`w-full ${error ? 'border-red-500' : ''}`}
              disabled={isLoading}
            />
            {error && (
              <p className="text-sm text-red-600">{error}</p>
            )}
            <p className="text-xs text-gray-500">
              Mínimo 10 caracteres
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-6 border-t bg-gray-50">
          <Button
            variant="outline"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={isLoading}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {isLoading ? 'Declinando...' : 'Declinar Solicitud'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeclineModal;
